import { Component, OnInit, HostListener } from '@angular/core';

import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-nav-bar-ucp',
    templateUrl: './nav-bar-ucp.shared.component.html',
    styleUrls: ['./nav-bar-ucp.shared.component.scss']
})
export class NavBarUcpComponent implements OnInit {
    public cartLocationName$!: Observable<string>;
    public showCollectionTypeToggle$!: Observable<boolean>;
    constructor(
        public controllers: Controllers,
    ) { }

    ngOnInit(): void {
        this.cartLocationName$ = this.controllers.cart.cartLocationFriendlyName$();
        this.showCollectionTypeToggle$ = this.controllers.collectionType.showCollectionToggleForHomePage$();
    }

    public get showCart(): boolean {
        return this.controllers.appSettings.appModeLoyaltyOnly === false;
    }
}
